export const designSkills = [
  "Gameplay & systems design",
  "Level design & encounter pacing",
  "UX / menu flow design",
  "Prototyping in Unity & Unreal",
  "Playtesting & iteration",
];

export const technicalSkills = [
  "C#, C++, JavaScript",
  "Unity & Unreal Engine",
  "React / Node full-stack dev",
  "Git & version control",
  "Blender / basic tooling",
];